import React from "react";
import moment from "moment-timezone";
import {
  Grid,
  Box,
  Typography,
  Button as MUIButton,
  Card,
  CardContent,
  Stack,
  Avatar,
  Chip,
  Divider,
} from "@mui/material";
import { FaCheckCircle } from "react-icons/fa";
import { MdArrowDropUp, MdArrowDropDown } from "react-icons/md";
import BetslipPayout from "../BetslipPayout";
import { PlayerCardImageUrl } from "../../constant/Environment";
import { Col, Row } from "react-bootstrap";
import { formatAmount } from "../../Utility/functions/Helper";

const ConfirmReceipt = ({
  visibility,
  apidata,
  playerlength,
  sameTeam,
  entry,
  multiplierResponse,
  closeconfirmbox,
}) => {

  const minBetCorrect = (multiplierResponse.length) - 1;

  return (
    <Box sx={{ display: visibility ? "none" : "block" }}>
      <Card
        variant="outlined"
        sx={{
          borderRadius: 3,
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            px: 3,
            py: 1.5,
            bgcolor: (t) => t.palette.success.light + "22",
            borderBottom: (t) => `1px solid ${t.palette.divider}`,
          }}
        >
          <FaCheckCircle style={{ color: "#2e7d32", fontSize: "24px" }} />
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            Contest Entry Confirmed
          </Typography>
        </Box>

        <CardContent sx={{ p: 0 }}>
          {apidata.map((item, idx) => {
            const date = item?.event_time;
            const confirm_time = moment(date).format("MMM D, h:mm a");

            let playerImage = "";
            if (item?.image) {
              if (item?.image.includes("https://")) {
                playerImage = item?.image;
              } else {
                playerImage = `${PlayerCardImageUrl}/${item?.image}`;
              }
            } else {
              playerImage = `${PlayerCardImageUrl}/player/player.png`;
            }

            return (
              <Box key={`${item?.playerId || item?.id || date || idx}`}>
                <Grid
                  container
                  // spacing={2}
                  alignItems="center"
                  sx={{ px: 3, py: 1.5 }}
                  className="row g-2"
                >
                  <Grid item xs={4} sm={3} md={2} lg={2} className="col-lg-2 col-md-2 col-4">
                    <Avatar
                      src={playerImage}
                      alt={item?.name || "player"}
                      variant="rounded"
                    // sx={{ width: { xs: 56, sm: 72 }, height: { xs: 56, sm: 72 }, borderRadius: 2, flexShrink: 0 }}
                    />
                  </Grid>

                  <Grid item xs={8} sm={9} md={10} lg={10} className="col-lg-10 col-md-10 col-sm-9 col-8">
                    <Stack spacing={0.75}>
                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        gap={1}
                      >
                        <Typography
                          // variant="h6"
                          // sx={{ fontWeight: 700, lineHeight: 1.2 }}
                          sx={{ fontSize: 16, fontWeight: 700 }}
                        >
                          {item?.name}
                        </Typography>
                      </Stack>

                      <Stack
                        direction="row"
                        spacing={1}
                        alignItems="center"
                        sx={{ minWidth: 0 }}
                      >
                        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                          {item?.game_type === 2 ? (
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: 700, color: "text.primary" }}
                              noWrap
                            >
                              {item?.single_event}
                            </Typography>
                          ) : (
                            <Typography
                              variant="body2"
                              sx={{ color: "text.secondary" }}
                              noWrap
                            >
                              {item?.position}
                              <Box
                                component="span"
                                sx={{ mx: 1, color: "text.disabled" }}
                              >
                                |
                              </Box>
                              <Box
                                component="span"
                                sx={{ fontWeight: 500, color: "text.primary" }}
                              >
                                {item?.team === item?.teamH?.teamId
                                  ? item?.teamH?.abv
                                  : item?.teamA?.abv}{" "}
                                {item?.team === item?.teamH?.teamId
                                  ? "vs"
                                  : "@"}{" "}
                                {item?.team === item?.teamH?.teamId
                                  ? item?.teamA?.abv
                                  : item?.teamH?.abv}
                              </Box>
                            </Typography>
                          )}
                        </Box>
                        <Typography
                          variant="caption"
                          sx={{ color: "text.secondary", mt: 0.5 }}
                        >
                          {confirm_time}
                        </Typography>
                      </Stack>
                      <Stack
                        direction="row"
                        spacing={1}
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{ minWidth: 0 }}
                      >
                        <Box
                          sx={{
                            ml: "auto",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 1,
                            px: 1.25,
                            py: 0.5,
                            borderRadius: 1.5,
                            border: (t) => `1px solid ${t.palette.divider}`,
                            bgcolor: (t) => t.palette.background.paper,
                            width: "fit-content",
                            flexShrink: 0,
                          }}
                        >
                          <Typography
                            variant="subtitle2"
                            sx={{ fontWeight: 800, lineHeight: 1 }}
                          >
                            {item?.points}
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{ opacity: 0.8, lineHeight: 1 }}
                          >
                            {item?.marketAbv?.length<=7?item?.marketAbv:item?.marketAbv?.slice(0,7)+".."}
                          </Typography>
                        </Box>

                        {item?.isMore === true && (
                          <Chip
                            icon={<MdArrowDropUp />}
                            label="MORE"
                            color="success"
                            size="small"
                            sx={{
                              fontWeight: 600,
                              height: 28,
                              borderRadius: 999,
                              px: 1.5,
                              "& .MuiChip-icon": { fontSize: 20, mr: 0 },
                            }}
                          />
                        )}
                        {item?.isLess === true && (
                          <Chip
                            icon={<MdArrowDropDown />}
                            label="LESS"
                            color="error"
                            size="small"
                            sx={{
                              fontWeight: 600,
                              height: 28,
                              borderRadius: 999,
                              px: 1.5,
                              "& .MuiChip-icon": { fontSize: 20, mr: 0 },
                            }}
                          />
                        )}
                      </Stack>
                    </Stack>
                  </Grid>
                </Grid>
                {idx < apidata?.playerData?.length - 1 && (
                  <Divider
                    sx={{ mx: 3, borderColor: (t) => t.palette.grey[700] }}
                  />
                )}
              </Box>
            );
          })}
        </CardContent>

        <Box sx={{ px: 3, py: 1.5 }}>

          {/* <BetslipPayout
            betslipLength={playerlength}
            samesport={sameTeam}
            wager={entry}
            multiplier={multiplierResponse}
          /> */}
          <div
            className="payoutbox p-2 mb-2"
            style={{
              border: "2px solid #0D3862",
              borderRadius: "15px",
              marginBottom: "5px",
              backgroundColor: "#f8f9fa"
            }}
          >
            <Row className="payoutrow">
              <Col lg={12} style={{ marginBottom: "4px" }}>
                <h6>
                  You must at least get {multiplierResponse[minBetCorrect]?.players}{" "}
                  player selections correct to qualify for a payout
                </h6>
              </Col>

              {multiplierResponse?.map((tier, index) => (
                <React.Fragment key={index}>
                  <Col lg={4} xs={4}>
                    <h6 style={{ fontWeight: "600" }}>{tier?.players} Correct</h6>
                  </Col>
                  <Col lg={4} xs={4} className="times">
                    <p style={{ textAlign: "initial" }}>{`${tier?.multiplier?.toFixed(2)}X`}</p>
                  </Col>
                  <Col lg={4} xs={4} className="amount">
                    <p style={{ textAlign: "initial" }}>${formatAmount(tier?.amount?.toFixed(2))}</p>
                  </Col>
                </React.Fragment>
              ))}
            </Row>
          </div>

          <MUIButton
            variant="contained"
            color="error"
            onClick={closeconfirmbox}
            fullWidth
            sx={{ mt: 2, borderRadius: 2 }}
          >
            Close
          </MUIButton>
        </Box>
      </Card>
    </Box>
  );
};

export default ConfirmReceipt;
